import { useCallback } from "react";
import styled from "styled-components";
import { BASIC_BROWN, BASIC_LINE } from "../../constants/colors";
import { useNavigation } from "../../hooks/useNavigation";

type Props = {
  text: string;
  href?: string;
  color?: string;
  newTab?: boolean;
  onClick?: () => void;
  size?: "sm" | "md" | "lg";
  underline?: boolean;
  fontSize?: string;
  fontWeight?: number;
  fontFamily?: string;
  external?: boolean;
  labelBorderBottom?: boolean;
};

export const Link: React.FC<Props> = ({
  text,
  href,
  color,
  newTab,
  onClick,
  size = "sm",
  underline,
  fontSize,
  fontFamily,
  fontWeight = 500,
  external,
  labelBorderBottom,
}) => {
  const { navigateToPage, navigateToNewTab } = useNavigation();

  const handleOnClick = useCallback(() => {
    if (onClick) onClick();
    if (!href) return;
    if (newTab) {
      if (external) window.open(href, "_blank");
      else navigateToNewTab(href);
    } else {
      if (external) window.location.href = href;
      else navigateToPage(href);
    }
  }, []);

  return (
    <LinkContainer
      size={size}
      $underline={underline ?? false}
      fontSize={fontSize}
      fontFamily={fontFamily}
      fontWeight={fontWeight}
      color={color ?? BASIC_BROWN}
      onClick={handleOnClick}
      $labelBorderBottom={labelBorderBottom ?? false}
    >
      {text}
    </LinkContainer>
  );
};

const LinkContainer = styled.div<{
  color: string;
  size: "sm" | "md" | "lg";
  fontWeight: number;
  fontSize?: string;
  fontFamily?: string;
  $underline: boolean;
  $labelBorderBottom: boolean;
}>`
  font-size: ${({ fontSize, size }) =>
    fontSize
      ? fontSize
      : size === "sm"
        ? "12px"
        : size === "md"
          ? "16px"
          : "20px"};

  font-weight: ${({ fontWeight }) => fontWeight};
  font-family: ${({ fontFamily }) => fontFamily};
  color: ${(props) => props.color};
  text-decoration: ${({ $underline }) => ($underline ? "underline" : "none")};
  margin: 0;
  line-height: 1;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  ${({ $labelBorderBottom }) =>
    $labelBorderBottom &&
    `
    display: block;
    border-bottom: 1px solid ${BASIC_LINE};
    padding-bottom: 20px ;
    margin-bottom: 22px;
  `}
`;
